import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { handleAddTaskToSchedualer } from "../store/actions/scheduallerActions";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
   import { format } from "date-fns";
import { FaCalendarAlt, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { ICONS } from "../constants/constants";
import Loader from "../assets/images/loader.gif";


const AddTaskModal = ({
  show,
  handleClose,
  productList,
  selectedCropScheduallerData,
 
}) => {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);


  const [tasks, setTasks] = useState([
    {
      task_category: "",
      task_description: "",
      assigned_date: "",
      due_date: "",
      products: [{ productId: "", quantityPerAcre: "" }],
    },
  ]);

   const [errors, setErrors] = useState({}); // ✅ errors state

  const validateTasks = () => {
    let newErrors = {};
    tasks.forEach((task, index) => {
      if (!task.task_category) newErrors[`task_category_${index}`] = "Task category is required";
      if (!task.task_description) newErrors[`task_description_${index}`] = "Description is required";
      if (!task.assigned_date) newErrors[`assigned_date_${index}`] = "Start date is required";
      if (!task.due_date) newErrors[`due_date_${index}`] = "End date is required";

        if (task.task_category === "Inputs") {
        task.products.forEach((p, pIndex) => {
          if (!p.productId) newErrors[`productId_${index}_${pIndex}`] = "Product is required";
          if (!p.quantityPerAcre) newErrors[`quantity_${index}_${pIndex}`] = "Quantity is required";
        });
      }
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleTaskChange = (taskIndex, name, value) => {
    const updated = [...tasks];
    updated[taskIndex][name] = value;

    // Reset products if task_category changed away from Inputs
    if (name === "task_category" && value !== "Inputs") {
      updated[taskIndex].products = [];
    }
    if (name === "task_category" && value === "Inputs" && !updated[taskIndex].products.length) {
      updated[taskIndex].products = [{ productId: "", quantityPerAcre: "" }];
    }

    setTasks(updated);
    setErrors((prev) => {
  const updatedErrors = { ...prev };
  delete updatedErrors[`${name}_${taskIndex}`];
  return updatedErrors;
});

  };

  const handleProductChange = (taskIndex, productIndex, name, value) => {
    const updated = [...tasks];
    updated[taskIndex].products[productIndex][name] = value;
    setTasks(updated);
   // ✅ Clear correct product-related validation error
  setErrors((prev) => {
    const updatedErrors = { ...prev };
    if (name === "quantityPerAcre") {
      delete updatedErrors[`quantity_${taskIndex}_${productIndex}`]; // match validateTasks key
    } else {
      delete updatedErrors[`${name}_${taskIndex}_${productIndex}`];
    }
    return updatedErrors;
  });
  };

  const addProduct = (taskIndex) => {
    const updated = [...tasks];
    updated[taskIndex].products.push({ productId: "", quantityPerAcre: "" });
    setTasks(updated);
    
  };

  const removeProduct = (taskIndex, productIndex) => {
    const updated = [...tasks];
    updated[taskIndex].products.splice(productIndex, 1);
    setTasks(updated);
  };

  const addTask = () => {
    setTasks([
      ...tasks,
      {
        task_category: "",
        task_description: "",
        assigned_date: "",
        due_date: "",
        products: [],
      },
    ]);
  };

  const removeTask = (index) => {
    const updated = [...tasks];
    updated.splice(index, 1);
    setTasks(updated);
  };

// const handleSubmit = async () => {
//   const schedualerId = selectedCropScheduallerData?.schedualer?.id;
//   if (!schedualerId) return;

//   try {
//     let allSuccess = true;

//     for (const task of tasks) {
//       const payload = {
//         task_category: task.task_category,
//         task_description: task.task_description,
//         assigned_date: task.assigned_date ? format(task.assigned_date, "MM-dd") : "",
//         due_date: task.due_date ? format(task.due_date, "MM-dd") : "",
//         products: task.task_category === "Inputs" ? task.products : [],
//       };

//       const result = await dispatch(handleAddTaskToSchedualer(schedualerId, payload));

//       if (!result?.payload?.success) {
//         allSuccess = false;
//         console.warn("Failed to add task:", result?.payload?.message || "Unknown error");
//         break;
//       }
//     }

//     if (allSuccess) {
//       setTasks([
//         {
//           task_category: "",
//           task_description: "",
//           assigned_date: "",
//           due_date: "",
//           products: [{ productId: "", quantityPerAcre: "" }],
//         },
//       ]);
//       handleClose();
//       window.location.reload(); // ✅ Refresh only after all tasks are successfully added
//     }

//   } catch (error) {
//     console.error("Error adding task:", error);
//   }
// };
const handleSubmit = async () => {
  if (!validateTasks()) return;

  const schedualerId = selectedCropScheduallerData?.schedualer?.id;
  if (!schedualerId) return;

  setLoading(true); // ✅ show loader

  try {
    const payload = {
      tasks: tasks.map((task) => ({
        task_category: task.task_category,
        task_description: task.task_description,
        assigned_date: task.assigned_date ? format(task.assigned_date, "MM-dd") : "",
        due_date: task.due_date ? format(task.due_date, "MM-dd") : "",
        products: task.task_category === "Inputs" ? task.products : [],
      })),
    };

    const result = await dispatch(handleAddTaskToSchedualer(schedualerId, payload));
    console.log("AddTaskToSchedualer result:", result);

    if (result?.statusCode === 200) {
      // ✅ reset form and close modal
      setTasks([
        {
          task_category: "",
          task_description: "",
          assigned_date: "",
          due_date: "",
          products: [{ productId: "", quantityPerAcre: "" }],
        },
      ]);

      handleClose(); // ✅ Close modal
      window.location.reload(); // optional: refresh page if needed
    } else {
      console.warn("Failed to add tasks:", result?.payload?.message || "Unknown error");
    }
  } catch (error) {
    console.error("Error adding tasks:", error);
  } finally {
    setLoading(false); // ✅ always hide loader
  }
};


  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Add Task</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted mb-4">Enter task(s) details</p>

        {tasks.map((task, index) => (
          <div key={index} className="mb-4 p-3 border rounded">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h6 className="mb-0">Task {index + 1}</h6>
              {index > 0 && (
                <span
                  className="underline-text"
                  onClick={() => removeTask(index)}
                >
                  Remove Task
                </span>
              )}
            </div>

            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Task Category<span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Select
                    value={task.task_category}
                    onChange={(e) =>
                      handleTaskChange(index, "task_category", e.target.value)
                    }
                  >
                    <option value="">Select</option>
                    
                    <option value="Land Prep">Land Prep</option>
                     <option value="Sowing">Sowing</option>
                     <option value="Inputs">Inputs</option>
                    <option value="Irrigation">Irrigation</option>
                    <option value="Harvesting">Harvesting</option>
                   
                  </Form.Select>
                  {errors[`task_category_${index}`] && <p className="text-danger">{errors[`task_category_${index}`]}</p>}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Task Description<span style={{ color: 'red' }}>*</span></Form.Label>
                  <Form.Control
                    placeholder="Enter task description"
                    value={task.task_description}
                    onChange={(e) =>
                      handleTaskChange(index, "task_description", e.target.value)
                    }
                  />
                  {errors[`task_description_${index}`] && <p className="text-danger">{errors[`task_description_${index}`]}</p>}
                </Form.Group>
              </Col>
            </Row>

            {/* <Row className="mt-3">
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Start Date (MM-DD)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g., 07-15"
                    value={task.assigned_date}
                    onChange={(e) =>
                      handleTaskChange(index, "assigned_date", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>End Date (MM-DD)</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="e.g., 07-20"
                    value={task.due_date}
                    onChange={(e) =>
                      handleTaskChange(index, "due_date", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row> */}


            <Row className="mt-3">
  <Col md={6}>
    <Form.Group>
      <Form.Label>Start Date (MM-DD)<span style={{ color: 'red' }}>*</span></Form.Label>
      <div className="date-picker-container position-relative">
        <DatePicker
          selected={task.assigned_date ? new Date(task.assigned_date) : null}
          onChange={(date) =>
            handleTaskChange(index, "assigned_date", date)
          }
          dateFormat="MM-dd"
          placeholderText="MM-DD"
          className="form-control"
          // showMonthDropdown
          // showYearDropdown
          yearDropdownItemNumber={50}
          scrollableYearDropdown

          // ✅ custom header for arrows
  renderCustomHeader={({
    date,
    decreaseMonth,
    increaseMonth,
    decreaseYear,
    increaseYear,
  }) => (
    <div className="d-flex justify-content-between align-items-center px-2">
      
      {/* Year arrows */}
      <button type="button" onClick={decreaseYear} className="btn btn-sm">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">{date.getFullYear()}</span>

      <button type="button" onClick={increaseYear} className="btn btn-sm">
        <FaChevronRight />
      </button>

      {/* Month arrows */}
      <button type="button" onClick={decreaseMonth} className="btn btn-sm ms-3">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">
        {date.toLocaleString("default", { month: "long" })}
      </span>

      <button type="button" onClick={increaseMonth} className="btn btn-sm">
        <FaChevronRight />
      </button>
    </div>
  )}
        />
        <img src={ICONS.calenderIcon} className="calendar-icon" alt="Calender" />
      </div>
      {errors[`assigned_date_${index}`] && <p className="text-danger">{errors[`assigned_date_${index}`]}</p>}
    </Form.Group>
  </Col>

  <Col md={6}>
    <Form.Group>
      <Form.Label>End Date (MM-DD)<span style={{ color: 'red' }}>*</span></Form.Label>
      <div className="date-picker-container position-relative">
        <DatePicker
          selected={task.due_date ? new Date(task.due_date) : null}
          onChange={(date) =>
            handleTaskChange(index, "due_date", date)
          }
          dateFormat="MM-dd"
          placeholderText="MM-DD"
          className="form-control"
          // showMonthDropdown
          // showYearDropdown
          yearDropdownItemNumber={50}
          scrollableYearDropdown

          // ✅ custom header for arrows
  renderCustomHeader={({
    date,
    decreaseMonth,
    increaseMonth,
    decreaseYear,
    increaseYear,
  }) => (
    <div className="d-flex justify-content-between align-items-center px-2">
      
      {/* Year arrows */}
      <button type="button" onClick={decreaseYear} className="btn btn-sm">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">{date.getFullYear()}</span>

      <button type="button" onClick={increaseYear} className="btn btn-sm">
        <FaChevronRight />
      </button>

      {/* Month arrows */}
      <button type="button" onClick={decreaseMonth} className="btn btn-sm ms-3">
        <FaChevronLeft />
      </button>

      <span className="fw-bold">
        {date.toLocaleString("default", { month: "long" })}
      </span>

      <button type="button" onClick={increaseMonth} className="btn btn-sm">
        <FaChevronRight />
      </button>
    </div>
  )}
        />
        <img src={ICONS.calenderIcon} className="calendar-icon" alt="Calender" />
      </div>
       {errors[`due_date_${index}`] && <p className="text-danger">{errors[`due_date_${index}`]}</p>}
    </Form.Group>
  </Col>
</Row>


            {/* Products only for Inputs */}
            {task.task_category === "Inputs" && (
              <div className="mt-4">
                <h6>Products</h6>
                {task.products.map((product, pIndex) => (
                  <Row key={pIndex} className="mb-2">
                    <Col md={5}>
                      <Form.Group>
                        <Form.Label>Product<span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Select
                          value={product.productId}
                          onChange={(e) =>
                            handleProductChange(index, pIndex, "productId", e.target.value)
                          }
                        >
                          <option value="">Select</option>
                          {productList?.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.productName}
                            </option>
                          ))}
                        </Form.Select>
                         {errors[`productId_${index}_${pIndex}`] && <p className="text-danger">{errors[`productId_${index}_${pIndex}`]}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={5}>
                      <Form.Group>
                        <Form.Label>Quantity per Acre<span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Control
                          type="number"
                          value={product.quantityPerAcre}
                          onChange={(e) =>
                            handleProductChange(index, pIndex, "quantityPerAcre", e.target.value)
                          }
                        />
                         {errors[`quantity_${index}_${pIndex}`] && <p className="text-danger">{errors[`quantity_${index}_${pIndex}`]}</p>}
                      </Form.Group>
                    </Col>
                    <Col md={2} className="d-flex align-items-end">
                      {pIndex > 0 && (
                        <Button
                          className="underline-text p-0 border-0 bg-transparent"
                          onClick={() => removeProduct(index, pIndex)}
                        >
                          Remove
                        </Button>
                      )}
                    </Col>
                  </Row>
                ))}
                <Button className="add-task p-0 border-0 mb-3" onClick={() => addProduct(index)}>
                
   <span className="fs-2 m-0 pt-1">+</span><span className="underline-text">Add Product</span>
                
                </Button>
              </div>
            )}
          </div>
        ))}

        <Button className="add-task p-0 border-0 mb-3" onClick={addTask}>
   <span className="fs-2 m-0 pt-1">+</span><span className="underline-text">Add New Task</span>
</Button>


        <div className="text-center mt-4">
          <Button className="button px-5" onClick={handleSubmit}>
            Save
          </Button>
        </div>

        {loading && (
  <div className="loaderOverlay">
    <img src={Loader} alt="Loading..." className="loaderImage" />
  </div>
)}

      </Modal.Body>
    </Modal>
  );
};

export default AddTaskModal;
